import * as types from "../../actions/actionTypes";

const initialState = {
  listLoading: true,
  listError: "",
  listData: [],

  initLoading: true,
  initError: "",
  initData: {},

  processing: false,
  last_item: {},

  data: {},
  loading: true,
  error: "",

  showData: {},
  showLoading: true,
  showError: "",

  removeProcessing: false
};

const PettyCashierMonthlyBudget = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_REQUEST:
      return { ...state, listLoading: true, listError: "", listData: [] };
    case types.PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_SUCCESS:
      return {
        ...state,
        listData: action.payLoad,
        listLoading: false
      };
    case types.PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_FAILURE:
      return { ...state, listLoading: false, listError: action.error };

    case types.PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_REQUEST:
      return { ...state, initLoading: true, initError: "" };
    case types.PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_SUCCESS:
      return {
        ...state,
        initData: action.payLoad,
        initLoading: false
      };
    case types.PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_FAILURE:
      return { ...state, initLoading: false, initError: action.error };

    case types.PETTY_CASHIER_EMPTY_MONTHLY_BUDGET_CACHED_DATA_FOR_CREATE:
      return { ...state, initData: {}, showData: {} };

    case types.PETTY_CASHIER_STORE_MONTHLY_BUDGET_REQUEST:
      return { ...state, processing: true };
    case types.PETTY_CASHIER_STORE_MONTHLY_BUDGET_SUCCESS:
      return {
        ...state,
        last_item: action.payLoad,
        processing: false
      };
    case types.PETTY_CASHIER_STORE_MONTHLY_BUDGET_FAILURE:
      return { ...state, processing: false };

    case types.PETTY_CASHIER_SHOW_MONTHLY_BUDGET_REQUEST:
      return { ...state, showLoading: true, showError: "" };
    case types.PETTY_CASHIER_SHOW_MONTHLY_BUDGET_SUCCESS:
      return {
        ...state,
        showData: action.payLoad,
        showLoading: false
      };
    case types.PETTY_CASHIER_SHOW_MONTHLY_BUDGET_FAILURE:
      return { ...state, showLoading: false, showError: action.error };

    case types.PETTY_CASHIER_GET_MONTHLY_BUDGET_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.PETTY_CASHIER_GET_MONTHLY_BUDGET_SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        loading: false
      };
    case types.PETTY_CASHIER_GET_MONTHLY_BUDGET_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_REQUEST:
      return { ...state, processing: true };
    case types.PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_SUCCESS:
      return {
        ...state,
        last_item: action.payLoad,
        processing: false,
        showData: action.payLoad
      };
    case types.PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_FAILURE:
      return { ...state, processing: false };

    case types.PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_REQUEST:
      return { ...state, removeProcessing: true };
    case types.PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_SUCCESS:
      return {
        ...state,
        removeProcessing: false
      };
    case types.PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_FAILURE:
      return { ...state, removeProcessing: false };

    default:
      return state;
  }
};

export default PettyCashierMonthlyBudget;
